var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m16 3l4 4l-4 4m-6-4h10M8 13l-4 4l4 4m-4-4h9"
    }, null, -1)
  ]));
}
__name(render, "render");
const switchHorizontal = markRaw({ name: "tabler-switch-horizontal", render });
export {
  switchHorizontal as default
};
//# sourceMappingURL=switch-horizontal.js.map
